module.exports = __webpack_public_path__ + "img/mt13.e7d6331a.jpg";